// extracted by mini-css-extract-plugin
export default {"button":"Back_button__mRD3i","text":"Back_text__Nmubv","icon":"Back_icon__phAPs"};